import { Controller } from "@hotwired/stimulus"

// Controller for handling OTP resend cooldown timer
export default class extends Controller {
  static targets = ["button", "cooldown", "cooldownMessage"]
  static values = {
    cooldown: Number
  }

  connect() {
    if (this.cooldownValue > 0) {
      this.startCooldown()
    }
  }

  disconnect() {
    this.stopCooldown()
  }

  // Automatically called when cooldownValue changes (e.g., after Turbo navigation)
  cooldownValueChanged() {
    this.stopCooldown()
    if (this.cooldownValue > 0) {
      this.startCooldown()
    }
  }

  startCooldown() {
    // Guard against overlapping intervals (cooldownValueChanged + connect both call this)
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
    // Store expiration timestamp for accurate time tracking
    this.cooldownExpiration = Date.now() + (this.cooldownValue * 1000)

    // Disable button if it exists
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
    }

    // Initial UI update
    this.updateCooldownUI()

    // Update UI every second
    this.intervalId = setInterval(() => {
      this.updateCooldownUI()
    }, 1000)
  }

  stopCooldown() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  updateCooldownUI() {
    // Calculate remaining time based on actual timestamp
    const now = Date.now()
    const remainingMs = Math.max(0, this.cooldownExpiration - now)
    const remainingSeconds = Math.ceil(remainingMs / 1000)

    // Check if cooldown finished
    if (remainingSeconds <= 0) {
      this.stopCooldown()
      this.enableResend()
      return
    }

    // Update display
    this.updateCooldown(remainingSeconds)
  }

  updateCooldown(remainingSeconds) {
    if (this.hasCooldownTarget) {
      if (remainingSeconds > 0) {
        this.cooldownTarget.textContent = `${remainingSeconds}s`
      } else {
        this.cooldownTarget.textContent = ""
      }
    }
  }

  enableResend() {
    // Hide the cooldown message container
    if (this.hasCooldownMessageTarget) {
      const messageContainer = this.cooldownMessageTarget.closest('[data-controller="otp-resend"]')
      if (messageContainer) {
        messageContainer.classList.toggle('hidden', true)
      }
    }

    // Notify countdown-timer (parent controller) to show the resend section
    this.dispatch("cooldown-expired")

    // Enable button if it exists
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false
    }

    if (this.hasCooldownTarget) {
      this.cooldownTarget.textContent = ""
    }
  }
}

